<p-dialog
  [visible]="visible()"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="w-full max-w-6xl"
  data-testid="subcriteria-scores-modal"
>
  <ng-template #header>
    <div>
      <h2 class="text-xl font-semibold mb-1">
        @if (toolId()) {
          {{ toolName() }}
        } @else {
          {{ 'project.steps.providerResults.title' | transloco }}
        }
      </h2>
    </div>
  </ng-template>

  @if (loading()) {
    <app-loading />
  } @else if (providerScores()) {
    <app-generic-questionnaire
      [readonly]="true"
      [providerScores]="providerScores()!"
      [tenderId]="tenderId()"
      [phaseType]="phaseType()"
      [tenderStatus]="tenderStatus()"
    />
  }
</p-dialog>
